/* "Nirvik Ready for admins" (/guides/admins): its own chapters around the shared organization ones. */
import role from './00-role.md?raw';
import members from './01-members.md?raw';
import inboxes from './02-inboxes.md?raw';
import routine from './03-routine.md?raw';
import { sharedChapters } from '../chapters';
import type { Guide } from '../types';

const s = sharedChapters('admins');

export const adminsGuide: Guide = {
  slug: 'admins',
  title: 'Nirvik Ready for admins',
  subtitle:
    'How to set up your organization, bring people in, assign courses, follow progress and answer your members.',
  audiences: ['admins'],
  pdf: '/guides/admins/nirvik-ready-guide.pdf',
  reviewed: '2026-10-25',
  chapters: [
    {
      slug: 'role',
      title: 'Your role as an admin',
      summary: 'What’s yours, and parent organizations',
      markdown: role,
    },
    s['set-up'],
    s.people,
    {
      slug: 'members',
      title: 'Members and groups, day to day',
      summary: 'Engagement, profiles, groups, roles and join requests',
      markdown: members,
    },
    s.assign,
    s.impact,
    {
      slug: 'inboxes',
      title: 'Feedback and help requests',
      summary: 'Your two inboxes and the daily digest',
      markdown: inboxes,
    },
    s.trust,
    {
      slug: 'routine',
      title: 'A simple admin routine',
      summary: 'Weekly, monthly and every term',
      markdown: routine,
    },
    s['checklists-faq'],
  ],
};
